import ApplicationController from "./application_controller";

export default class extends ApplicationController {
  static targets = [];

  connect() {
    console.log("connected xlsx_controller.js");
  }
  export() {
    event.preventDefault();
    event.stopPropagation();

    let type = "xlsx";
    let dl = undefined;
    let fn = "download.xlsx";
    let sheetname = "sheet1";

    var elt = this.element.querySelector("table");

    var wb = XLSX.utils.table_to_book(elt, {
      sheet: sheetname,
      raw: false,
      cellStyles: true,
    });
    const ws = wb.Sheets[sheetname];

    ws["!cols"] = this.xlsxTableWidtsForHtmlTable(elt, ws);

    return dl
      ? XLSX.write(wb, {
          bookType: type,
          bookSST: true,
          type: "base64",
          cellStyles: true,
        })
      : XLSX.writeFile(wb, fn || "MySheetName." + (type || "xlsx"));
  }

  xlsxTableWidtsForHtmlTable (ws) {
    var eltRows = this.element.querySelectorAll("tr");
    var colCount = this.element.querySelectorAll("thead th").length;
    var rowCount = this.element.querySelectorAll("tr").length;
    /*
     * Loop through the html table by column and row
     * and find the maximum text lengths
     * set the max length as column width
     */
    let colWidths = new Array(colCount);
    for (let i = 0; i < colCount; i++) {
      colWidths[i] = { wch: 10 };
      for (let j = 0; j < rowCount; j++) {
        let tdCells = Array.from(eltRows[j].querySelectorAll("td,th"));
        if (tdCells[i] == undefined) {
          continue;
        }
        if (tdCells[i].innerText.length > colWidths[i].wch) {
          colWidths[i].wch = tdCells[i].innerText.length;
        }
        if (tdCells[i].dataset.t != undefined) {
          var xlsxCell = ws[XLSX.utils.encode_cell({ r: j, c: i })];
          xlsxCell.t = tdCells[i].dataset.t;
        }
      }
    }
    return colWidths;
  };
}
